import EditSurveyQuestionCard from './editSurveyQuestionCard.container'

export default EditSurveyQuestionCard